<div class="wrapper">
  <h3 class="header" [attr.data-testid]="testIds.privacyHeader">Nutzung Anwendung TI-Messenger (TI-M)</h3>
  <section>
    <h2 class="subheader">Beschreibung und Umfang der Datenverarbeitung</h2>
    <span>
      Der Mitarbeitende kann in der TI-M Pro Anwendung über den TI-M mit berechtigten Akteuren (Leistungserbringer,
      Leistungserbringerinstitutionen, Kostenträger und Versicherte) kommunizieren, sofern diese einer
      Gesprächseinladung durch den Mitarbeitenden zustimmen. Darüber hinaus können berechtigte Akteure den
      Mitarbeitenden kontaktieren, wenn dieser einer Kommunikation zustimmt.</span
    >
  </section>
  <section>
    <h2 class="subheader">Kommunikation zwischen dem TI-M Pro und anderen TI-M-Teilnehmern</h2>
    <span>
      Die Kommunikation findet über den TI-M Pro Web-Client im Browser des Mitarbeitenden statt und befähigt diesen mit
      anderen von der gematik zugelassenen TI-M-Diensten zu kommunizieren. Die Kommunikation zwischen den TI-M-Diensten
      erfolgt Ende-zu-Ende-verschlüsselt. Die Adressierung der Akteure innerhalb von TI-M erfolgt über die TI-M-Adresse.
      Zusätzlich zu den technischen systemseitigen Prüfungen, die im Hintergrund stattfinden, soll der TI-M-Nutzer
      selbst bestimmen können, wer ihn in neue Chaträume einladen darf. Dies dient dem Nutzer zur eigenständigen
      Steuerung seines Chataufkommens.
    </span>
  </section>
  <section>
    <h2 class="subheader">Art der Daten</h2>
    <span>
      Die Krankenkasse erhebt und verarbeitet zur initialen Einrichtung und anschließenden Verwaltung des TI-M
      personenbezogene Daten des Nutzers. Diese Daten sind nachstehend aufgeführt:
    </span>
    <ol class="list">
      <li class="list-header">Daten die bei jeder Nutzung von TI-M verarbeitet werden müssen</li>
      <ol class="nested-list">
        <li>E-Mail-Adresse des Nutzers</li>
        <li>TI-M-Adresse</li>
        <li>interne Geräte-ID</li>
        <li>Version des Betriebssystems</li>
        <li>Zeitpunkt des Zugriffs</li>
        <li>IP-Adresse</li>
      </ol>

      <li class="list-header">Inhalte der Chatkommunikation</li>
      <ol class="nested-list">
        <li>
          Die Verarbeitung der Inhalte der Chatkommunikation unterscheidet sich je nachdem, welche Akteure am Chat
          beteiligt waren. Die Kasse als Anbieter des TI-Messengers Pro speichert grundsätzlich alle Inhalte der
          Chatkommunikation verschlüsselt ab.
        </li>
        <li>
          Die Krankenkasse hat keine Möglichkeit, Chatinhalte von Konversationen einzusehen, an denen sie nicht
          beteiligt ist/war, z.B. Kommunikation zwischen Versicherten und Leistungserbringer ohne Beteiligung der
          Krankenkasse.
        </li>
      </ol>
      <li class="list-header">3. Freiwillige Einwilligung zur Datenverarbeitung:</li>
      <ol class="nested-list">
        <li>
          Push-Benachrichtigung: Die Aktivierung dieser Funktion erfolgt freiwillig durch die Zustimmung des Nutzers und
          kann jederzeit in den Einstellungen vom Nutzer deaktiviert werden.
        </li>
      </ol>
    </ol>
  </section>
  <section>
    <h2 class="subheader">Zweck der Datenverarbeitung</h2>
    <span>
      Zweck der Datenverarbeitung ist die Bereitstellung und die Nutzung der Anwendung TI-M durch den Mitarbeitenden der
      Krankenkasse zur Teilnahme an einem sicheren, interoperablen elektronischen Sofortnachrichtendienst. Es ist
      wichtig zu verstehen, dass jedwede Chat-Kommunikation mit anderen TI-M-Teilnehmern eine automatische
      Datenverarbeitung nach sich zieht, um die Funktionsfähigkeit des Dienstes zu gewährleisten.
    </span>
  </section>
  <section>
    <h2 class="subheader">Dauer der Speicherung</h2>
    <span>
      Die Daten werden gelöscht, sobald sie für die Erreichung des Zweckes ihrer Erhebung nicht mehr erforderlich sind
      und keine Aufbewahrungspflichten mehr bestehen. Für den Nutzer besteht zudem die Möglichkeit seine Daten im
      TI-Messenger selbst zu verwalten und löschen.</span
    >
    <ol class="list">
      <li>Der Nutzer kann Daten selbst löschen</li>
      <li>Daten, die durch die Nutzung entstehen (Umfasst Chatkommunikationen, technische/betriebliche Daten)</li>
      <li>Die Krankenkasse kann eine automatische Löschfrist festlegen</li>
    </ol>
  </section>
  <section>
    <h2 class="subheader">Benutzerinhalte</h2>
    Alle Inhalte, die Sie über die Chat-Kommunikation des TI-M austauschen - seien es Texte, Bilder, Dokumente oder-
    sind durch eine Ende-zu-Ende-Verschlüsselung davor geschützt, dass Dritte, die nicht Teilnehmende des Chats sind,
    diese Inhalte sehen können. Dazu gehören insbesondere auch die verantwortliche Krankenkasse und der
    IT-Dienstleister. Der Nutzer ist selbst für die Inhalte verantwortlich, die er mit anderen Teilnehmenden einer
    Chat-Kommunikation teilt.
  </section>
  <section>
    <h2 class="subheader">Beschäftigtendatenschutz</h2>
    Werden Sozialdaten automatisiert verarbeitet oder genutzt, ist die innerbehördliche oder innerbetriebliche
    Organisation so zu gestalten, dass sie den besonderen Anforderungen des Datenschutzes gerecht wird. Dabei sind
    insbesondere Maßnahmen zu treffen, die je nach der Art der zu schützenden Sozialdaten oder Kategorien von
    Sozialdaten geeignet sind,
    <ul>
      <li>
        Unbefugten den Zugang zu Datenverarbeitungsanlagen, mit denen Sozialdaten verarbeitet oder genutzt werden, zu
        verwehren (Zutrittskontrolle),
      </li>
      <li>zu verhindern, dass Datenverarbeitungssysteme von Unbefugten genutzt werden können (Zugangskontrolle),</li>
      <li>
        zu gewährleisten, dass die zur Benutzung eines Datenverarbeitungssystems Berechtigten ausschließlich auf die
        ihrer Zugriffsberechtigung unterliegenden Daten zugreifen können, und dass Sozialdaten bei der Verarbeitung,
        Nutzung und nach der Speicherung nicht unbefugt gelesen, kopiert, verändert oder entfernt werden können
        (Zugriffskontrolle).
      </li>
    </ul>
    <h2 class="subheader">Hinweise zu den Rechten als Betroffener</h2>
    Bei Fragen zur Verarbeitung Ihrer Daten und zur Ausübung Ihrer Rechte gemäß der DSGVO wenden Sie sich bitte direkt
    an den Arbeitgeber und/oder IT-Dienstleister, BITMARCK GmbH. Dieser ist der datenschutzrechtlich Verantwortliche und
    somit für die Bearbeitung Ihrer Anliegen zuständig.
  </section>
</div>
